import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function safe(v: any) {
  if (v === null || v === undefined) return "";
  if (typeof v === "boolean") return v ? "Ja" : "Nein";
  return String(v);
}

function get(obj: any, path: string[]) {
  return path.reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export function exportPdf(formData: any) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });

  const title = "PiT – Ausgefülltes Formular (Demo)";
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(title, 40, 50);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Erstellt am: ${new Date().toLocaleString("de-DE")}`, 40, 70);

  let y = 90;

  // ---------- Section helper ----------
  const section = (name: string) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(name, 40, y);
    y += 12;
    doc.setDrawColor(220);
    doc.line(40, y, 555, y);
    y += 12;
  };

  const keyValueTable = (rows: Array<[string, any]>) => {
    autoTable(doc, {
      startY: y,
      head: [["Feld", "Wert"]],
      body: rows.map(([k, v]) => [k, safe(v)]),
      styles: { font: "helvetica", fontSize: 9, cellPadding: 6, valign: "top" },
      headStyles: { fontStyle: "bold" },
      columnStyles: { 0: { cellWidth: 210 }, 1: { cellWidth: 305 } },
      margin: { left: 40, right: 40 }
    });
    // @ts-ignore
    y = doc.lastAutoTable.finalY + 16;
  };

  // ---------- 1) Sozialdaten ----------
  section("Sozialdaten – Antrag stellende Person");
  const p = get(formData, ["Sozialdaten", "Antrag stellende Person"]) || {};
  keyValueTable([
    ["Geschlecht", p["Geschlecht"]],
    ["Vorname", p["Vorname"]],
    ["Nachname", p["Nachname"]],
    ["Zusatz", p["Zusatz"]],
    ["Geburtsdatum", p["Geburtsdatum"]],
    ["Geburtsort", p["Geburtsort"]],
    ["Straße", p["Straße"]],
    ["Hausnummer", p["Hausnummer"]],
    ["Postleitzahl", p["Postleitzahl"]],
    ["Wohnort", p["Wohnort"]],
    ["Wohnsituation", get(p, ["Wohnsituation", "value"])],
    ["Wohnsituation – professionelle Unterstützung", get(p, ["Wohnsituation", "mit professioneller Unterstützung"])],
    ["Beschäftigung", get(p, ["Beschäftigungssituation", "value"])],
    ["Beschäftigung – professionelle Unterstützung", get(p, ["Beschäftigungssituation", "mit professioneller Unterstützung"])],
    ["Telefon", p["Telefon"]],
    ["Fax", p["Fax"]],
    ["E-Mail-Adresse", p["E-Mail-Adresse"]],
    ["Familienstand", p["Familienstand"]],
    ["Staatsangehörigkeit", p["Staatsangehörigkeit"]]
  ]);

  // Kommunikationshilfen (booleans)
  section("Kommunikationshilfen");
  const kh = p["Kommunikationshilfen"] || {};
  keyValueTable([
    ["Dolmetscher", kh["Dolmetscher"]],
    ["Unterstützte Kommunikation", kh["Unterstützte Kommunikation"]],
    ["Gebärdensprache", kh["Gebärdensprache"]],
    ["Visualisierungen", kh["Visualisierungen"]],
    ["Lormen", kh["Lormen"]],
    ["Technische Hilfen", kh["Technische Hilfen"]],
    ["Andere Kommunikationshilfe erforderlich", kh["Andere Kommunikationshilfe erforderlich"]],
    ["Sprache Dolmetscher", p["Sprache Dolmetscher"]],
    ["Andere Kommunikationshilfe (Text)", get(p, ["Andere Kommunikationshilfe", "value"])],
    ["Assistenz im Krankenhaus erforderlich", get(p, ["Andere Kommunikationshilfe", "Assistenz im Krankenhaus erforderlich"])]
  ]);

  // ---------- 2) Lebenslage / Beschäftigung (narrative) ----------
  section("Lebenslage / Sozialraum / Beschäftigung");
  const ll = get(formData, ["Bisherige und aktuelle Lebenslage, Sozialraumbezug, Beschäftigung"]) || {};
  keyValueTable([
    ["Beschreibung der Lebenslage", ll["Beschreibung der Lebenslage"]],
    ["Beschreibung der Ausbildungs-, Beschäftigungssituation", ll["Beschreibung der Ausbildungs-, Beschäftigungssituation"]]
  ]);

  // ---------- 3) Leistungen & Unterstützungen (table) ----------
  section("Bisherige und aktuelle Leistungen und Unterstützungen");
  const supports: any[] = formData["Bisherige und aktuelle Leistungen und Unterstützungen"] || [];
  autoTable(doc, {
    startY: y,
    head: [["Leistung oder Unterstützung", "Unterstützende Person oder Dienst"]],
    body: supports.map((s) => [safe(s?.["Leistung oder Unterstützung"]), safe(s?.["Unterstützende Person oder Dienst"])]),
    styles: { font: "helvetica", fontSize: 9, cellPadding: 6, valign: "top" },
    headStyles: { fontStyle: "bold" },
    margin: { left: 40, right: 40 }
  });
  // @ts-ignore
  y = doc.lastAutoTable.finalY + 16;

  // ---------- 4) Wünsche / Lebensziele ----------
  section("Wünsche und Lebensziele");
  keyValueTable([["Wünsche und Lebensziele", formData["Wünsche und Lebensziele"]]]);

  // ---------- 5) Teilhabeziele ----------
  section("Teilhabeziele");
  const tz = formData["Teilhabeziele"] || {};

  const socialGoals: any[] = tz["Soziale Teilhabe"] || [];
  if (socialGoals.length) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(10);
    doc.text("Soziale Teilhabe", 40, y); y += 10;
    autoTable(doc, {
      startY: y,
      head: [["Ziel", "Art", "Indikator"]],
      body: socialGoals.map((g) => [
        safe(g?.["Ziel zur sozialen Teilhabe"]),
        safe(g?.["Art des Ziels zur sozialen Teilhabe"]),
        safe(g?.["Indikator für das Ziel zur sozialen Teilhabe"])
      ]),
      styles: { font: "helvetica", fontSize: 9, cellPadding: 6, valign: "top" },
      headStyles: { fontStyle: "bold" },
      margin: { left: 40, right: 40 }
    });
    // @ts-ignore
    y = doc.lastAutoTable.finalY + 16;
  }

  const workGoals: any[] = tz["Teilhabe am Arbeitsleben"] || [];
  if (workGoals.length) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(10);
    doc.text("Teilhabe am Arbeitsleben", 40, y); y += 10;
    autoTable(doc, {
      startY: y,
      head: [["Ziel", "Art", "Indikator"]],
      body: workGoals.map((g) => [
        safe(g?.["Ziel zur Teilhabe am Arbeitsleben"]),
        safe(g?.["Art des Ziels zur Teilhabe am Arbeitsleben"]),
        safe(g?.["Indikator für das Ziel zur Teilhabe am Arbeitsleben"])
      ]),
      styles: { font: "helvetica", fontSize: 9, cellPadding: 6, valign: "top" },
      headStyles: { fontStyle: "bold" },
      margin: { left: 40, right: 40 }
    });
    // @ts-ignore
    y = doc.lastAutoTable.finalY + 16;
  }

  const eduGoals: any[] = tz["Teilhabe an Bildung"] || [];
  if (eduGoals.length) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(10);
    doc.text("Teilhabe an Bildung", 40, y); y += 10;
    autoTable(doc, {
      startY: y,
      head: [["Ziel", "Art", "Indikator"]],
      body: eduGoals.map((g) => [
        safe(g?.["Ziel zur Teilhabe an Bildung"]),
        safe(g?.["Art des Ziels zur Teilhabe an Bildung"]),
        safe(g?.["Indikator für das Ziel zur Teilhabe an Bildung"])
      ]),
      styles: { font: "helvetica", fontSize: 9, cellPadding: 6, valign: "top" },
      headStyles: { fontStyle: "bold" },
      margin: { left: 40, right: 40 }
    });
    // @ts-ignore
    y = doc.lastAutoTable.finalY + 16;
  }

  const med = tz["Medizinische Rehabilitation"] || {};
  if (med["Ziel zur medizinischen Rehabilitation"]) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(10);
    doc.text("Medizinische Rehabilitation", 40, y); y += 10;
    keyValueTable([["Ziel zur medizinischen Rehabilitation", med["Ziel zur medizinischen Rehabilitation"]]]);
  }

  doc.save("pit-formular-demo.pdf");
}
